<draft-editor [draft]="draft" *ngIf="draft" (onSaved)="onSaved()" (onLockDraft)="onLockDraft()"
              (onUnlockDraft)="onUnlockDraft()" (onDraftChanged)="onDraftChanged()"
              (onDraftChangesCanceled)="onDraftChangesCanceled()"></draft-editor>
